import * as React from 'react';
import { IListItem } from '@nkr/models/index';
import { Col, ControlLabel, Form, FormControl, FormGroup, Panel, Row, Table } from 'react-bootstrap';
import { TableWrapper } from '../styles';

interface IProps {
    requiredTubeList: IListItem[],
    labLavender85: number,
    labLavender40: number,
    labLavender70: number,
    labLavender100: number,
    labPink60: number,
    labPink100: number,
    labRed70: number,
    labRed100: number,
    labGreen100: number,
    labYellow85: number,
    onChange: (e: React.FormEvent<FormControl & HTMLSelectElement>) => void
}

const CrossMatchTubes = (props: IProps) => {
    const {
        labLavender85, labLavender40, labLavender70, labLavender100,
        labPink60, labPink100, labRed70, labRed100,
        labGreen100, labYellow85
    } = props;

    const tubeMap = [
        {
            color: 'Lavender', tubes: [
                { size: '3.0 ml [367856]', property: 'labLavender85' },
                { size: '4.0 ml [367861]', property: 'labLavender40' },
                { size: '7.0 ml [367863]', property: 'labLavender70' },
                { size: '10.0 ml [366643]', property: 'labLavender100' },
            ]
        },
        {
            color: 'Pink', tubes: [
                { size: '6.0 ml [367899]', property: 'labPink60' },
                { size: '10.0 ml [366643]', property: 'labPink100' },
            ]
        },
        {
            color: 'Red', tubes: [
                { size: '7.0 ml [367815]', property: 'labRed70' },
                { size: '10.0 ml [367820]', property: 'labRed100' },
            ]
        },
        {
            color: 'Green', tubes: [
                { size: '10.0 ml [367874]', property: 'labGreen100' },
            ]
        },
        {
            color: 'Yellow', tubes: [
                { size: '8.5 ml [364606]', property: 'labYellow85' },
            ]
        }
    ]

    return (
        <Panel>
            <Panel.Heading>
                Cross Match Tubes
            </Panel.Heading>
            <Panel.Body>
                <TableWrapper condensed>
                    <tbody>
                        {tubeMap.map(item =>
                            <tr>
                                <td><strong>{item.color}:</strong></td>
                                {item.tubes.map(t =>
                                    <>
                                        <td>{t.size}</td>
                                        <td>
                                            <FormControl
                                                componentClass='select'
                                                id={t.property}
                                                value={eval(t.property)}
                                                onChange={props.onChange}
                                            >
                                                {props.requiredTubeList.map(tube =>
                                                    <option value={tube.id}>{tube.description}</option>
                                                )}
                                            </FormControl>
                                        </td>
                                    </>
                                )}
                            </tr>
                        )}
                    </tbody>
                </TableWrapper>
            </Panel.Body>
            <Panel.Footer>
                (Please indicate the tubes your center requires from the donor center for a crossmatch)
            </Panel.Footer>
        </Panel>
    );
}

export default CrossMatchTubes;